<template>
  <header class="header">
    <nav>
      <div class="logo-section">
        <img :src="logo_image" alt="Apertura logo" class="logo">
      </div>
      <div class="links-section">
        <div class="header-nav-link">
          <router-link to="/">Home</router-link>
        </div>
        <div class="header-nav-link">
          <router-link to="/discover">Discover</router-link>
        </div>
        <div class="header-nav-link" v-if="loggedIn">
          <router-link to="/albums">My Albums</router-link>
        </div>
        <div class="header-nav-link" v-if="loggedIn">
          <router-link to="/contests">Contests</router-link>
        </div>
        <div class="header-nav-link">
          <router-link to="/about">About</router-link>
        </div>
        <div class="header-nav-link" v-if="loggedIn">
          <router-link to="/profile">My Account</router-link>
        </div>

        <div class="header-nav-link" v-if="loggedIn && (isAdmin || isOrgAdmin)">
          <router-link to="/user-mgmt">Users</router-link>
        </div>
        <div class="header-nav-link" v-if="loggedIn && isAdmin">
          <router-link to="/myorganizationspage">Organizations</router-link>
        </div>
        <div class="header-nav-link" v-if="loggedIn && isAdmin">
          <router-link to="/showloginspage">Logins</router-link>
        </div>
        <div class="header-nav-link" v-if="loggedIn && (isAdmin || isOrgAdmin)">
          <router-link to="/registration-mgmt">Registration</router-link>
        </div>
        <div class="header-nav-link" v-if="loggedIn && (isAdmin || isModerator)">
          <router-link to="/moderation">Moderation</router-link>
        </div>


      </div>
      <div class="logout-section">
        <div class="login-logout-item header-nav-link">
          <router-link to="/logout-confirmation" @click.native="logout" class="login-logout-link header-nav-link">
            <i class="fas" :class="{ 'fa-sign-in-alt': !loggedIn, 'fa-sign-out-alt': loggedIn }"></i>
            {{ loggedIn ? 'Logout' : 'Login' }}
          </router-link>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import logo_image from '@/assets/apertura_logo.png'
import {ref, computed, watch} from 'vue'
import {useRoute} from 'vue-router'

const emit = defineEmits(['logout'])

const route = useRoute()

function getRoles() {
  try {
    return JSON.parse(localStorage.getItem('roles') || '[]')
  } catch {
    return []
  }
}

const roles = ref(getRoles())
const loggedIn = ref(localStorage.getItem('loggedIn') === 'true')

const isAdmin = computed(() => roles.value.includes('ADMIN'))
const isOrgAdmin = computed(() => roles.value.includes('ORG_ADMIN'))
const isModerator = computed(() => roles.value.includes('MODERATOR'))

watch(
    () => route.fullPath,
    () => {
      roles.value = getRoles()
      loggedIn.value = localStorage.getItem('loggedIn') === 'true'
    }
)

function logout() {
  localStorage.clear()
  emit('logout')
}

</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 10px 20px;
  height: 4rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

nav {
  display: flex;
  gap: 1rem;
  height: fit-content;
  width: 100%;
}

.links-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  gap: 1rem;
}

.header-nav-link * {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: black;
  text-decoration: none;
  padding: 0.4rem;
  box-sizing: border-box;
  margin: 0;
  transition: all 0.25s ease-in-out;
}

.header-nav-link:hover * {
  border-radius: 10px;
  background-color: #f4f4f4;
}

.logo-section {
  display: flex;
  align-items: center;
  text-align: right;

}

.logo {
  width: 8rem;
}

h1 {
  color: #13294B;
}
</style>